<template>
  <b-card
    :type="mode"
    :title="titleText"
    :submit-text="translations[mode]"
    :loading="loading"
    :error-message="errorMessage"
    @cancel="$emit('cancel')"
    @submit="submitForm()"
    >
        <div v-if="mode==='delete'" class="subtitle-1 font-weight-medium pt-2 px-2">
            {{ translations.deleteWarningPart1[lang] }}
            <span class="font-weight-bold text--primary">{{
                item.friendly_name
            }}</span
            >             {{ translations.deleteWarningPart2[lang] }}
            <span class="font-weight-bold text--primary">{{ item.cash_register_code }}</span>             
            {{ translations.questionmark[lang] }}
        </div>
        <div v-else>

        <b-text-field
            v-model="item.friendly_name"
            :label="translations.friendlyName[lang]"
            :success="!!item.friendly_name"
            :error-messages="error.friendly_name"
            @focus="error.friendly_name = ''"
            @blur="validateFriendlyName"
        >
        </b-text-field>

        <b-text-field
            v-model="item.cash_register_code"
            :label="translations.code[lang]"
            :success="!!item.cash_register_code"
            :error-messages="error.cash_register_code"
            @focus="error.cash_register_code = ''"
            @blur="validateCode"
        >
        </b-text-field>
        </div>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import validators from "@/utils/validators/storePanel/cashRegisters";
import translations from "@/utils/translations/storePanel/settings/profile/cashRegisters";

export default {
    name: "CashRegisterDialog",

    props: {
        mode: {
            type: String,
            default: "create"
        },
        item: {
            type: Object,
            default: () => ({})
        },
    },

    mixins: [validators, translations],

    data() {
        return {
         
        };
    },

    computed: {
        ...mapState([
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),
       
        loading() {
            return this.$store.state.storePanel.profile.loading.cashRegisters;
        },
        titleText(){
            return `${(this.mode==='update' ? this.translations.edit : this.translations[this.mode])[this.lang]} ${this.translations.formtitle[this.lang]}`
        },
     

        lang() {
            return this.$route.params.lang;
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapActions("storePanel/profile", [
            "createCashRegister",
            "updateCashRegister",
            "deleteCashRegister"
        ]),

        async submitForm() {
            this.validateFriendlyName()
            this.validateCode()
            if(this.formValid)
               await this[this.mode + 'CashRegister'](this.item)
            this.$emit('cancel')
        },
    },

    watch: {
        // item: {
        //     handler(val) {
        //         if (!val.update_store_products.status) {
        //             val.update_store_products.prices_included = false;
        //         }
        //         if (!val.has_valid_period) {
        //             val.valid_from = null;
        //             val.valid_to = null;
        //         }
        //         if(!!val.valid_from || !!val.valid_to){
        //             val.has_valid_period = true
        //         }
        //     },
        //     deep: true,
        // },
    },

    mounted() {
        // this.getCategories();
        // this.getProductsTags();
    },
};
</script>
